import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  ImportedQuestion,
  TestImportTargetPreview,
  TestImportCommit,
  TestImportPreview,
  TestImportRequest,
  TestImportResult,
} from '../../interfaces/test-import';
import {
  ApiCollectionResponse,
  ApiSingleResponse,
} from '../../interfaces/responses/api-response';

/**
 * Import d'un référentiel (Word ou PDF) vers la banque de questions.
 *
 * Le parcours tient en trois appels et deux d'entre eux n'écrivent rien : on
 * analyse, on projette le mapping pour que l'utilisateur relise, et seulement
 * ensuite on valide.
 */
@Injectable({ providedIn: 'root' })
export class TestImportService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.BASE_URL}/professor/tests/import`;

  /** Extrait le tableau du fichier déposé et propose un mapping. N'écrit rien. */
  analyze(request: TestImportRequest): Observable<TestImportPreview> {
    return this.http
      .post<ApiSingleResponse<TestImportPreview>>(`${this.baseUrl}/analyze`, request)
      .pipe(map((r) => r.data));
  }

  /** Montre, par matière visée, les questions que le mapping produirait. N'écrit rien. */
  preview(command: TestImportCommit): Observable<TestImportTargetPreview[]> {
    return this.http
      .post<ApiCollectionResponse<TestImportTargetPreview>>(`${this.baseUrl}/preview`, command)
      .pipe(map((r) => r.data ?? []));
  }

  /** Crée les questions relues, en brouillon et en attente de validation. */
  commit(command: TestImportCommit): Observable<TestImportResult> {
    return this.http
      .post<ApiSingleResponse<TestImportResult>>(`${this.baseUrl}/commit`, command)
      .pipe(map((r) => r.data));
  }
}
